<div class="tab-pane active" id="policies" role="tabpanel">

    <div class="row mb-4">
        <div class="col-lg-12 col-md-12 form-inline">
            <label name="searchPolicies" id="searchPoliciesID" class="label_cls mr-2">Search Policies</label>
            <div class="input-group search_policies mousePointer">
                <span class="p-input-icon-right">
                    <i class="pi pi-search"></i>
                    <input autocomplete="off" type="text" class="filter_search_wid global_search_wid" pInputText name="searchPoliciesFilter" 
                    style="height: 2.5rem;" id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"  [(ngModel)]="policyNumberModal"
                    (input)="policyGrid.filterGlobal($event.target.value, 'contains')" (completeMethod)="getPolicyBasedOnNumber($event)" />
                </span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <span name="policy30days" id="policy30daysID" class="heading_search_policies">
                Policies <small>(past 30 days)</small>
            </span>
            <span class="float-right text-right">
                <span name="Export" id="ExportID" class="search_policies_link mousePointer " (click)="exportExcel(policyGrid)">
                    <i name="ExportIcon" id="ExportIconID" class="fa fa-file-excel-o excel_icon_cls mr-1" style="font-size: 16px;"
                        aria-hidden="true"></i> 
                        Export </span>
                <span class="center_line"> | </span>
                <span name="ViewAll" id="ViewAllID" class="search_policies_link mousePointer" style="color:#007bff" (click)="ViewAll()">{{viewALL?"View Less":"View All"}}</span>
            </span>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 mt-0 mb-0">
            <p-table name="policiesGrid" class="table_column" id="policiesGridID" #policyGrid [globalFilterFields]="['policyNumber','nameInsured']" class="policySearch gen-paginator-override" [value]="policiesList" [style]="{width:'100%'}" 
            [rows]="!viewALL?10:null" [paginator]="!viewALL && policiesList.length>0?true:false" pageLinks="{{!viewALL?8:null}}" 
            columnResizeMode="expand" [resizableColumns]="true" styleClass="p-datatable-gridlines table_column">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="policyNumber_Column" pResizableColumn pSortableColumn="policyNumber">Policy Number<p-sortIcon
                                field="policyNumber"></p-sortIcon>
                                <p-columnFilter type="text" field="policyNumber" display="menu"></p-columnFilter>
                        </th>
                        <th width="130px" pResizableColumn pSortableColumn="nameInsured">Name Insured<p-sortIcon
                                field="nameInsured"></p-sortIcon>
                                <p-columnFilter type="text" field="nameInsured" display="menu"></p-columnFilter>
                        </th>
                        <th width="125px" pResizableColumn pSortableColumn="effectiveDate">Effective Date
                            <p-sortIcon field="date"></p-sortIcon>
                                <p-columnFilter type="text" field="effectiveDate" display="menu"></p-columnFilter>
                        </th>
                        <th width="110px" pResizableColumn pSortableColumn="expireDate">Expired Date<p-sortIcon field="expireDate">
                            </p-sortIcon>
                            <p-columnFilter type="text" field="expireDate" display="menu"></p-columnFilter>
                        </th>
                        <th width="140px" pResizableColumn pSortableColumn="lineOfBusinuss">Line of Business<p-sortIcon
                                field="lineOfBusinuss"></p-sortIcon>
                                <p-columnFilter type="text" field="lineOfBusinuss" display="menu"></p-columnFilter>
                        </th>
                        <th class="jobsite_Column" pResizableColumn pSortableColumn="jobSiteAddress">Jobsite Address<p-sortIcon
                                field="jobSiteAddress"></p-sortIcon>
                                <p-columnFilter type="text" field="jobSiteAddress" display="menu"></p-columnFilter>
                        </th>
                        <th width="160px" pResizableColumn pSortableColumn="status" class="text-center">Status<p-sortIcon
                                field="status"></p-sortIcon>
                                <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                        </th>
                        <th width="110px">&nbsp;</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-policies>
                    <tr>
                        <td>{{policies?.policyNumber}}</td>
                        <td >{{policies?.nameInsured}}</td>
                        <td>{{policies?.effectiveDate | date : 'MM/dd/yyyy'}}</td>
                        <td>{{policies?.expireDate | date : 'MM/dd/yyyy'}}</td>
                        <td>{{policies?.lineOfBusinuss}}</td>
                        <td>{{policies?.jobSiteAddress}}</td>
                        <td class="text-center">
                            <span style="display: flex; justify-content: center;text-transform: uppercase;">
                            <span [ngClass]="getColorCode(policies?.status)" >{{policies?.status}}</span>
                        </span>
                        </td>
                        <td class="text-center">
                        <p-dropdown name="wanttoaction" id="wanttoactionID" title="{{policies.value}}" appendTo="body" class="quotes_grid_dd" placeholder="I want to" [options]="policies?.wantedTo" [(ngModel)]="policies.value"
                        (onChange)="PolicyWantedTo(policies)" optionDisabled="disabled">
                            <ng-template let-target pTemplate="item">
                                <div style="pointer-events: all ;" pTooltip="{{(policies?.status == 'PendingCancellation' && target?.value == 'Cancel my policy') ? 'Pending BFM action' : ''}}">
                                    <div class="{{(policies?.status == 'PendingCancellation' && target?.value == 'Cancel my policy') ? 'bpmicanelcls' : ''}}" >{{target.label}}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No records found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <app-cancel-policy-popup [policyReasons]="reasonDropdown" [policyDetails]="currentPolicy" [IsCancel]="IsCancel" (pushCancelDetails)="pushCancelDetails($event)" *ngIf="showCancelPopup" [currentPolicy]="policyDetail" [cancelPopupDetails]="cancelPopupDetails" (popupEvent)="popUpClose($event)"></app-cancel-policy-popup>
    <p-dialog header="Policy Change Confirmation" [(visible)]="showPolicyConfirm" 
    (onHide)="showPolicyConfirm = false" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
    [closable]="true" [modal]="true" styleClass="EditMailingPopUp MailingPopUp">
        <div class="row mt-2">
            <div class="col-lg-12">
                <span class="confirmTxt">{{isBPMiAmend ? 'Your change has been submitted and will be completed by a Berkley Fire Marine specialist. The change item will stay in orange as pending until completion of change. A confirmation will be emailed when change is finalized.' : 'Amendment complete, you will receive a copy of your change request.'}}</span>
            </div>
        </div>
        <div class="row float-right mt-3">
            <button class="policyCloseBtn" (click)="showPolicyConfirm = false">Close</button>
        </div>
    </p-dialog>
</div>